import { render, staticRenderFns } from "./AppSummaryViewFlexiLife.vue?vue&type=template&id=5d096068&scoped=true"
import script from "./AppSummaryViewFlexiLife.vue?vue&type=script&lang=js"
export * from "./AppSummaryViewFlexiLife.vue?vue&type=script&lang=js"
import style0 from "./AppSummaryViewFlexiLife.vue?vue&type=style&index=0&id=5d096068&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d096068",
  null
  
)

export default component.exports